import type * as React from "react";
import { type FC } from "react";

import BulkATCPopupContext from "../../../../../../BulkATCPopup/components/BulkATCPopupContext";
import { Link } from "../../../../../../common/components/Link";
import { useTranslation } from "react-i18next";
import NoteAddOutlinedIcon from "@mui/icons-material/NoteAddOutlined";

interface BulkATCButtonProps {
  className?: string;
  isB2BCart?: boolean;
}

const CartBulkATCButton: FC<BulkATCButtonProps> = ({ className, isB2BCart = false }) => {
  const { t } = useTranslation();
  return (
    <BulkATCPopupContext>
      {({ openPopup }) => {
        const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
          e.preventDefault();
          openPopup();
        };

        return (
          <Link
            iconBefore={<NoteAddOutlinedIcon />}
            onClick={onClick}
            data-test-id={"btn-bulk-upload"}
            className={className}
          >
            {t("cartPage.btn.bulk")}
          </Link>
        );
      }}
    </BulkATCPopupContext>
  );
};

export default CartBulkATCButton;
